export const EVENT_PAY_TYPES = {
  FREE: 1,
  PAID: 2,
  PAID_STAGES: 3,
};

export const EVENT_PAY_TYPES_TEXT = {
  [EVENT_PAY_TYPES.FREE]: 'Бесплатно',
  [EVENT_PAY_TYPES.PAID]: 'Платно',
  [EVENT_PAY_TYPES.PAID_STAGES]: 'Платно, оплата по этапам',
};

export const EVENT_MEMBER_TYPE = {
  SINGLE: 1,
  TEAM: 2,
  SINGLE_TEAM: 3,
};

export const EVENT_MEMBER_TYPE_TEXT = {
  [EVENT_MEMBER_TYPE.SINGLE]: 'Одиночный',
  [EVENT_MEMBER_TYPE.TEAM]: 'Командный',
  [EVENT_MEMBER_TYPE.SINGLE_TEAM]: 'Смешанный',
};

export const EVENT_MEMBER_TYPE_TEXT_TRANSFER = {
  [EVENT_MEMBER_TYPE.SINGLE]: 'одного или нескольких участников',
  [EVENT_MEMBER_TYPE.TEAM]: 'одну или несколько команд',
  [EVENT_MEMBER_TYPE.SINGLE_TEAM]: 'одного или несколько участников/команд',
};

export const EVENT_MEMBER_TYPE_PREFIX_TRANSFER = {
  [EVENT_MEMBER_TYPE.SINGLE]: 'участников',
  [EVENT_MEMBER_TYPE.TEAM]: 'команд',
  [EVENT_MEMBER_TYPE.SINGLE_TEAM]: 'участников/команд',
};

export const EVENT_STAGE_FORMAT = {
  FULL_TIME: 1,
  PART_TIME: 2,
  DISTANCE: 3,
  FULL_PART_TIME: 4,
};

export const EVENT_STAGE_FORMAT_TEXT = {
  [EVENT_STAGE_FORMAT.FULL_TIME]: 'Очный',
  [EVENT_STAGE_FORMAT.PART_TIME]: 'Заочный',
  [EVENT_STAGE_FORMAT.DISTANCE]: 'Дистанционный',
  [EVENT_STAGE_FORMAT.FULL_PART_TIME]: 'Очно-заочный',
};

export const WITHOUT_MUNICIPALITY_PARAM = 0;

export const NULL_MODERATION_TEXT = {
  region: 'Отправить региональному оператору',
  municipality: 'Отправить муниципальному оператору',
};
